import React, { useEffect } from "react";
import CompanyCard from "./MiniComponents/CompanyCard/CompanyCard";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCompanies } from "../../../redux/companySlice/companySlice";

export default function Companies() {
  const dispatch = useDispatch();
  const { allCompanies } = useSelector((state) => state.company);
  useEffect(() => {
    dispatch(getAllCompanies());
  }, [dispatch]);

  return (
    <>
      <div className="main">
        <section>
          <div>
            <h1 className="text-white">الشركات</h1>
          </div>
          <div className="container-fluid">
            <div className="row justify-content-between align-items-center mb-5 mt-3">
              <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
                <div className="card py-2 px-3">
                  <p className="mb-0 primary-100">
                    عدد الشركات: <span className="primary-100">{allCompanies?.length}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-4 text-center mb-3">
                <input type="search" placeholder="ابحث ..." className="form-control search" />
              </div>
              <div className="col-md-4 text-md-end text-center">
                <Link className="btn btn-primary text-white" to={"/AddCompany"}>
                  إضافة شركة
                </Link>
              </div>
            </div>
            <div className="companies row align-items-center">{allCompanies && allCompanies.length > 0 && allCompanies.map((company) => <CompanyCard key={company.id} company={company} />)}</div>
          </div>
        </section>
      </div>
    </>
  );
}
